<template>
  <ValidationProvider :rules="validationRule" v-slot="{ errors, classes }" tag="div" class="form-group">
    <div>
      <label :for="name" :class="[classes, labelClass]"> {{ label }} </label>
      <textarea
        :name="name"
        class="form-control textarea"
        :class="classes"
        :placeholder="placeholder"
        :disabled="disabled"
        :rows="rows"
        :value="value"
        @input="$emit('input', $event.target.value)"
      />
      <div v-if="description" class="d-flex mt-3">
        <span class="mi mi-info text-info"></span>
        <p class="font-weight-normal ml-2 mb-0 text-small">{{ description }}</p>
      </div>
    </div>
    <ul class="errors">
      <li class="text-danger" v-for="(error,idx) in errors" :key="idx">{{ error }}</li>
    </ul>
  </ValidationProvider>
</template>

<script>
export default {
  name: 'basicTextarea',
  props: ['name', 'label', 'labelClass', 'placeholder', 'description', 'value', 'validationRule', 'disabled', 'rows'],
};

</script>

<style scoped lang="scss">
.textarea {
  resize: vertical;
}
</style>
